import styled from 'styled-components';

export const StyledDayTag = styled.div`
  border: 3px solid ${(props) => props.theme.color.primary};
  width: fit-content;
  padding: 0.25rem 0.75rem;
  border-radius: ${(props) => props.theme.radius.md};
  margin: 1rem auto;
`;
